import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Account = ({contact = {}, prefix = ''}) => (
  <Panes
    entity={contact}
    prefix={prefix}
    panes={[
      {
        title: 'Account Details',
        fields: [
          <TextField
            name="company_number"
            prefix={prefix}
            label="Company Number"
          />,
          <TextField
            name="vat_number"
            prefix={prefix}
            label="VAT Number"
          />,
          <TextField
            name="years_trading"
            prefix={prefix}
            label="Years Trading"
          />
        ]
      },
      {
        title: 'Bank Details',
        fields: [
          <TextField
            name="bank_name"
            prefix={prefix}
            label="Name"
          />,
          <TextField
            name="bank_address"
            prefix={prefix}
            label="Address"
            fieldProps={{multiline: true, rows: 4}}
          />,
          <TextField
            name="bank_account_number"
            prefix={prefix}
            label="Account Number"
          />,
          <TextField
            name="bank_sort_code"
            prefix={prefix}
            label="Sort Code"
          />
        ]
      }
    ]}
    title=""/>
);

Account.onSave = (
  {
    company_number,
    vat_number,
    years_trading,
    bank_name,
    bank_address,
    bank_account_number,
    bank_sort_code
  }
) => ({
  company_number,
  vat_number,
  years_trading,
  bank_name,
  bank_address,
  bank_account_number,
  bank_sort_code
});

export default Account;
